import ValidateRut from 'helpers/validateRut';
import * as yup from 'yup';

const SchemaReceptor = yup.object().shape({
  rutEmpresaReceptor: yup
    .string()
    .trim()
    .nullable()
    .matches(/^[^.\s]*$/, 'No se permiten puntos en este campo')
    .max(12, 'La cantidad máxima de caracteres es 11')
    .min(9, 'La cantidad mínima de caracteres es 9')
    .matches(/^[0-9]+[-|‐]{1}[0-9kK]{1}$/, 'Formato inválido (XXXXXXXX-X)')
    .test(
      'Evaluación de rut',
      'El rut ingresado es inválido',
      value => !value || ValidateRut.isValid(value)
    ),

  nombreEmpresaReceptor: yup
    .string()
    .trim()
    .max(128, 'La cantidad máxima de caracteres es 128')
    .min(2, 'La cantidad mínima de caracteres es 2')
    .nullable(),

  codigoSINADER: yup
    .string()
    .nullable()
    .min(4, 'La cantidad mínima de caracteres es de 4 dígitos')
    .max(7, 'La cantidad máxima de caracteres es de 7 dígitos'),

  // Nueva logica de validación de dirección
  comunaEmpresaReceptor: yup
    .object()
    .nullable()
    .test(
      'comuna-required-if-others-filled',
      'Este campo es obligatorio',
      function (value) {
        const { nombreViaEmpresaReceptor, regionEmpresaReceptor } = this.parent;
        if (nombreViaEmpresaReceptor || regionEmpresaReceptor) {
          return !!value; // Si alguno está completado, este campo debe ser obligatorio
        }
        return true; // Si todos están vacíos, no es obligatorio
      }
    ),

  nombreViaEmpresaReceptor: yup
    .string()
    .trim()
    .max(100, 'La cantidad máxima de caracteres es 100')
    .min(3, 'La cantidad mínima de caracteres es 3')
    .nullable()
    .test(
      'nombre-required-if-others-filled',
      'Este campo es obligatorio',
      function (value) {
        const { comunaEmpresaReceptor, regionEmpresaReceptor } = this.parent;
        if (comunaEmpresaReceptor || regionEmpresaReceptor) {
          return !!value; // Si alguno está completado, este campo debe ser obligatorio
        }
        return true;
      }
    ),

  regionEmpresaReceptor: yup
    .object()
    .nullable()
    .test(
      'region-required-if-others-filled',
      'Este campo es obligatorio',
      function (value) {
        const { comunaEmpresaReceptor, nombreViaEmpresaReceptor } = this.parent;
        if (comunaEmpresaReceptor || nombreViaEmpresaReceptor) {
          return !!value; // Si alguno está completado, este campo debe ser obligatorio
        }
        return true;
      }
    )
});

export { SchemaReceptor };
